import React from 'react';

export default function Hero() {
  return (
    <section id="hero" className="hero">
      <div className="hero__inner">
        <div className="hero__text">
          <div className="hero__tag">Software &amp; IT Services · Est. 2024</div>
          <h1 className="hero__headline">
            We engineer<br />
            software that<br />
            <em>scales.</em>
          </h1>
          <p className="hero__sub">
            Old Monk Tech is a cutting-edge software and IT services company
            blending the wisdom of tradition with the agility of modern technology.
            Built for businesses that refuse to be ordinary.
          </p>
          <div className="hero__btns">
            <a href="#products" className="btn-primary">See Our Work →</a>
            <a href="#contact" className="btn-ghost">Get in Touch</a>
          </div>
        </div>

        <div className="hero__visual">
          {/* Tech diagram SVG */}
          <svg width="460" height="380" viewBox="0 0 460 380" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* Grid lines */}
            {[0,1,2,3,4,5].map(i => (
              <line key={`h${i}`} x1="40" y1={50+i*56} x2="420" y2={50+i*56}
                stroke="#d4920e" strokeOpacity="0.07" strokeWidth="1" />
            ))}
            {[0,1,2,3,4,5,6].map(i => (
              <line key={`v${i}`} x1={40+i*63} y1="30" x2={40+i*63} y2="350"
                stroke="#d4920e" strokeOpacity="0.07" strokeWidth="1" />
            ))}

            {/* Central node */}
            <circle cx="230" cy="190" r="52" fill="#131009" stroke="#d4920e" strokeWidth="1.5" />
            <circle cx="230" cy="190" r="38" fill="#1c1811" stroke="#d4920e" strokeOpacity="0.3" strokeWidth="1" strokeDasharray="4 3" />
            <text x="230" y="186" textAnchor="middle" fill="#d4920e" fontFamily="'IBM Plex Mono', monospace" fontSize="11" fontWeight="500">OM</text>
            <text x="230" y="201" textAnchor="middle" fill="#8a7d6a" fontFamily="'IBM Plex Mono', monospace" fontSize="8">TECH</text>

            {/* Satellite nodes */}
            {[
              { cx: 100, cy: 90,  label: 'CLOUD',    sublabel: 'AWS · GCP' },
              { cx: 360, cy: 90,  label: 'SOFTWARE',  sublabel: 'Web · API' },
              { cx: 80,  cy: 290, label: 'SECURITY',  sublabel: 'Zero-Trust' },
              { cx: 380, cy: 290, label: 'DATA',       sublabel: 'Analytics' },
            ].map((n, i) => (
              <g key={i}>
                <line x1={n.cx} y1={n.cy} x2="230" y2="190"
                  stroke="#d4920e" strokeOpacity="0.15" strokeWidth="1" strokeDasharray="5 4" />
                <circle cx={n.cx} cy={n.cy} r="32" fill="#131009" stroke="#d4920e" strokeOpacity="0.4" strokeWidth="1" />
                <text x={n.cx} y={n.cy-4} textAnchor="middle" fill="#d4920e" fontFamily="'IBM Plex Mono', monospace" fontSize="7" fontWeight="500">{n.label}</text>
                <text x={n.cx} y={n.cy+9} textAnchor="middle" fill="#8a7d6a" fontFamily="'IBM Plex Mono', monospace" fontSize="6">{n.sublabel}</text>
              </g>
            ))}

            {/* Corner dots */}
            {[[50,50],[410,50],[50,330],[410,330]].map(([x,y],i) => (
              <circle key={i} cx={x} cy={y} r="3" fill="#d4920e" fillOpacity="0.3" />
            ))}

            {/* Blinking center dot */}
            <circle cx="230" cy="190" r="4" fill="#d4920e">
              <animate attributeName="opacity" values="1;0.2;1" dur="2.5s" repeatCount="indefinite" />
            </circle>
          </svg>

          <div className="hero__stats">
            <div>
              <div className="hero__stat-num">0→1</div>
              <div className="hero__stat-label">We build from scratch</div>
            </div>
            <div>
              <div className="hero__stat-num">Full</div>
              <div className="hero__stat-label">Stack ownership</div>
            </div>
            <div>
              <div className="hero__stat-num">Ship</div>
              <div className="hero__stat-label">We ship, you grow</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
